import React from "react";
import { hasMultipleDepartments, practiceDepartmentName, practiceDepartments } from "../config/practice";

/*
 * The booking form's Department field (owner 10-28): pre-selected with the
 * picked provider's department (useBookingDepartment), changeable by staff.
 * Rendered only for a practice with more than one department (9928); OSA and
 * single-location practices see no change.
 */
export default function BookingDepartmentSelect({
  value,
  ruleValue,
  onChange,
  id = "bookingDepartment",
  label = "Department",
  className = "h-10 px-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500",
  labelClassName = "font-inter text-sm my-1 text-left px-1",
  wrapperClassName = "flex flex-col",
}) {
  if (!hasMultipleDepartments()) return null;
  const departments = practiceDepartments();
  const shown = value === undefined || value === null ? "" : String(value);
  const changed = ruleValue !== undefined && ruleValue !== null && ruleValue !== "" && shown !== "" && shown !== String(ruleValue);
  return (
    <div className={wrapperClassName} data-testid="booking-department">
      <label htmlFor={id} className={labelClassName}>{label}</label>
      <select id={id} value={shown} onChange={(e) => onChange && onChange(e.target.value)} className={className}>
        {shown === "" && <option value="">Select department</option>}
        {departments.map((d) => (
          <option key={d.id} value={String(d.id)}>{d.name}</option>
        ))}
      </select>
      {changed && (
        <span className="text-xs text-amber-700 text-left px-1" data-testid="booking-department-changed">
          Changed from {practiceDepartmentName(ruleValue, String(ruleValue))} (provider's department)
        </span>
      )}
    </div>
  );
}
